import { render } from "./PageKullanicilar.vue?vue&type=template&id=6a7de3d6"
import script from "./PageKullanicilar.vue?vue&type=script&lang=js"
export * from "./PageKullanicilar.vue?vue&type=script&lang=js"
script.render = render

export default script